import { useState } from 'react';
import { LinearProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Routes from '@/router/Routes';
import BackButton from '@/components/ui/BackButton/BackButton';

const AdminUploadContentPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [currentStep] = useState(1);
  const totalSteps = 3;
  const progress = (currentStep / totalSteps) * 100;

  return (
    <div className="flex flex-col gap-6">
      <div className="flex items-center gap-2 mb-4">
        <BackButton route={Routes.ADMIN_DASHBOARD} />
      </div>

      <div className="mb-6">
        <div className="flex gap-1 mb-1 text-sm">
          <span className="text-[#00000099] font-semibold">{t('adminUploadContent.progressText')}</span>
          <span className="text-[#FF6B6B]">- {currentStep}/{totalSteps}</span>
        </div>
        <LinearProgress
          variant="determinate"
          value={progress}
          sx={{
            height: 10,
            borderRadius: 4,
            bgcolor: '#f0f0f0',
            '& .MuiLinearProgress-bar': {
              bgcolor: '#FF6B6B',
              borderRadius: 4,
            },
          }}
        />
      </div>

      <button
        onClick={() => navigate(Routes.ADMIN_UPLOAD_LESSON)}
        className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[205px] h-[44px] flex items-center justify-center gap-2 bg-[#FF6B6B] hover:bg-[#FF5252] text-white rounded-[120px] text-sm font-bold transition-colors"
      >
        {t('adminUploadContent.uploadButton')}
      </button>
    </div>
  );
};

export default AdminUploadContentPage;
